import React, { useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
type ModalProps = {
  open: boolean;
  onClose: () => void;
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
};
export function Modal({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer
}: ModalProps) {
  useEffect(() => {
    if (!open) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);
  return <AnimatePresence data-id="element-164" data-mp="ntvka3yg47">
      {open && <div className="fixed inset-0 z-50 flex items-start justify-center overflow-y-auto p-4 sm:items-center sm:p-6" data-id="element-165" data-mp="4z8tbhhjcvrl">
          <motion.button type="button" aria-label="Close dialog" onClick={onClose} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15
      }} className="fixed inset-0 h-full w-full cursor-default bg-ink/40" data-id="element-166" data-mp="9yv5ropji7zc" />
          <motion.div role="dialog" aria-modal="true" aria-label={title} initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        type: 'spring',
        stiffness: 420,
        damping: 34
      }} className="relative flex max-h-[88vh] w-full max-w-[640px] flex-col overflow-hidden rounded-xl bg-white shadow-2xl" data-id="element-167" data-mp="2rculsp3p4oef">
            <header className="flex items-start gap-3 border-b border-gray-200 px-5 py-4" data-id="element-168" data-mp="358pz8ffbt7af">
              <div className="min-w-0" data-id="element-169" data-mp="30awpjcetdv5e">
                <h2 className="truncate text-[16px] font-bold text-ink" data-id="element-170" data-mp="1l620xrltxmo">{title}</h2>
                {subtitle && <p className="mt-0.5 truncate text-[12.5px] text-gray-500" data-id="element-171" data-mp="3szlnx3ohjmdg">{subtitle}</p>}
              </div>
              <button type="button" onClick={onClose} aria-label="Close" className="ml-auto rounded-lg p-1.5 text-gray-500 transition-colors hover:bg-gray-100" data-id="element-172" data-mp="1r3w7i7fd05ih">
                <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-173" data-mp="1haxgkiwe42vp" />
              </button>
            </header>
            <div className="scrollbar-thin flex-1 overflow-y-auto" data-id="element-174" data-mp="18c3gujnriwdx">{children}</div>
            {footer && <div className="border-t border-gray-200 bg-gray-50 px-5 py-3" data-id="element-175" data-mp="1cdfad09rc1re">{footer}</div>}
          </motion.div>
        </div>}
    </AnimatePresence>;
}